import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { NgForm } from '@angular/forms';
import { ApiServices } from 'src/app/shared/api.services';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {

  title = "Terms & Conditions of Playfully";
  terms_conditions: string = "";
  config_id: string = "";
  selectedFile: File = null;
  upload_file_url: string = "";
  apiKey = '';

  public model = {
    terms_conditions: ''
  };

  constructor(private apiServices: ApiServices) {
    this.apiKey = apiServices.tinyApiKey;
  }

  ngOnInit() {
    this.getTermsConditions();
  }

  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }

  onSubmit(form: NgForm) {
    let data = form.value.text_data;
    this.apiServices.setTermsConditions(data, this.config_id).subscribe(res => {
      if (res['status'] === "failure") {
        this.apiServices.clearMessage();
        this.apiServices.sendTextMessage(res['msg'], 'failure');
      } else {
        this.apiServices.clearMessage();
        this.apiServices.sendTextMessage(res['msg'], 'success');
      }
    })
  }

  getTermsConditions() {
    this.apiServices.getConfigurations().subscribe(res => {
      if (res['status'] === "failure") {
        this.apiServices.clearMessage();
        this.apiServices.sendTextMessage(res['msg'], 'failure');
      } else {
        this.model.terms_conditions = res['data']['terms_conditions'];
        this.config_id = res['data']['_id'];
        this.apiServices.clearMessage();
        this.apiServices.sendTextMessage(res['msg'], 'success');
      }
    })
  }

  onFileChanged(event) {
    this.selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append('config_image', this.selectedFile, this.selectedFile.name);
    this.apiServices.uploadFile(fd).subscribe(res => {
      if (res['status'] == "failure") {
        this.apiServices.clearMessage();
      } else {
        this.apiServices.clearMessage();
        this.upload_file_url = res['data'];
        this.apiServices.sendTextMessage(this.upload_file_url, 'success');
      }
    });
  }
  /* To copy Text from Textbox */
  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    alert('copyed text');
  }


}
